// components/LanguageSwitcher/LanguageSwitcher.jsx
import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import { LanguageContext } from '../../core/Contexts/LanguageContext';
import {
  loadGoogleTranslate,
  changeGoogleLanguage,
} from '../../core/services/translationService';

const INTERVALS = {
  LABEL_CHECK: 1000,
  CHANGE_RESET: 300,
};

const LANGUAGE_OPTIONS = {
  GEORGIAN: { value: 'ka', text: 'ქარ' },
  ENGLISH: { value: 'en', text: 'ENG' },
};

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useContext(LanguageContext);
  const [isChanging, setIsChanging] = useState(false);
  const selectRef = useRef(null);

  // --- Load Google Translate only when needed ---
  useEffect(() => {
    if (language === LANGUAGE_OPTIONS.ENGLISH.value) {
      loadGoogleTranslate();
    }
  }, [language]);

  // --- Apply current language when it changes (or when GT becomes ready) ---
  useEffect(() => {
    const tryApply = () => changeGoogleLanguage(language);
    // Try now and keep retrying briefly until the combo exists
    if (language === LANGUAGE_OPTIONS.ENGLISH.value) {
      // We only need active translation when EN is selected
      tryApply();
    }
    const wait = setInterval(() => {
      const combo = document.querySelector('.goog-te-combo');
      if (combo) {
        if (language === LANGUAGE_OPTIONS.ENGLISH.value) {
          tryApply();
        }
        clearInterval(wait);
      }
    }, 300);
    return () => clearInterval(wait);
  }, [language]);

  // --- Keep fixing dropdown label texts (ENG/ქარ) ---
  const checkLabels = useCallback(() => {
    if (selectRef.current) {
      const options = selectRef.current.options;
      if (options[0] && options[0].text !== LANGUAGE_OPTIONS.GEORGIAN.text)
        options[0].text = LANGUAGE_OPTIONS.GEORGIAN.text;
      if (options[1] && options[1].text !== LANGUAGE_OPTIONS.ENGLISH.text)
        options[1].text = LANGUAGE_OPTIONS.ENGLISH.text;
    }
  }, []);

  useEffect(() => {
    checkLabels();
    const intervalId = setInterval(checkLabels, INTERVALS.LABEL_CHECK);
    return () => clearInterval(intervalId);
  }, [checkLabels]);

  // --- Handle language change from dropdown ---
  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    if (isChanging) return;

    setIsChanging(true);
    changeLanguage(newLang);
    changeGoogleLanguage(newLang);

    setTimeout(() => setIsChanging(false), INTERVALS.CHANGE_RESET);
  };

  return (
    <div>
      <select
        ref={selectRef}
        value={language}
        onChange={handleLanguageChange}
        disabled={isChanging}
      >
        <option value={LANGUAGE_OPTIONS.GEORGIAN.value}>
          {LANGUAGE_OPTIONS.GEORGIAN.text}
        </option>
        <option value={LANGUAGE_OPTIONS.ENGLISH.value}>
          {LANGUAGE_OPTIONS.ENGLISH.text}
        </option>
      </select>

      {/* Hidden Google Translate widget mount point */}
      <div id='google_translate_element' style={{ display: 'none' }}></div>
    </div>
  );
};

export default LanguageSwitcher;
